<template>
<select v-model="model">
    <option :value="null" :disabled="field.data.required" selected> {{ $t('form.select_option') }} </option>
    <option
        v-for="option in field.options"
        :key="option.id"
        :value="option.id.toString()"
    >
        {{$findTranslation(option, language).name}}
    </option>
</select>
</template>

<script>
export default {
    emits: ['input', 'update:modelValue'],
    name: 'SelectFieldForm',
    props: {
        field: {
            type: Object,
            required: true,
        },
        modelValue: String,
    },
    computed: {
        language() { return this.$store.getters.LANGUAGE; },
        model: {
            get() { return this.modelValue; },
            set(value) { this.$emit('update:modelValue', value); },
        },
    },
};
</script>
